export function getParentOrigin(): string | null {
  const searchParams = new URLSearchParams(window.location.search);
  const origin = searchParams.get("parentOrigin");

  if (!origin) {
    console.error("[Widget] Missing parentOrigin query parameter.");
    return null;
  }

  return origin;
}
